<template>
  <div><div class="minHieght100 main-content bg-primary-white mt-5 p-5">Sections</div></div>
</template>
